import AboutBrand from "./AboutBrand";
import ExplainTurtle from "./ExplainTurtle";
import { useEffect } from "react";
import "./About.css";

export default function AboutUs() {
  useEffect(() => {
    document.title = "Giới Thiệu Rumi";
  }, []);
  return (
    <main className="au">
      {" "}
      {/* <div className="pl-hero__imgWrap"> */}
      <img
        className="pl-hero__img"
        src="/images/slide/bg5.jpg"
        alt="Portrait"
      />
      {/* HERO banner */}
      <section className="au-hero" aria-label="Rumi — About our brand">
        <div className="au-hero__inner container">
          <p className="eyebrow">GIỚI THIỆU VỀ THƯƠNG HIỆU</p>
          <h2>RUMI</h2>
          <span className="line" />
        </div>
      </section>
      {/* Intro: image + text */}
      <section className="au-intro container">
        <figure className="au-intro__media">
          <img src="/images/logo1.png" alt="logo Rumi" />
        </figure>

        <div className="au-intro__text">
          <h2>Triết lý thương hiệu</h2>
          <p>
            Rumi ra đời từ tình yêu và sự thấu hiểu sâu sắc dành cho hành trình
            làm cha mẹ nơi từng giọt mồ hôi, từng nụ cười, từng giấc ngủ yên
            bình của con đều là điều quý giá nhất.
          </p>
          <p>
            Chúng tôi tin rằng, một chiếc tã êm ái, khô thoáng và an toàn không
            chỉ giúp bé dễ chịu, mà còn là cách để cha mẹ gửi gắm yêu thương,
            chở che con khôn lớn từng ngày trong vòng tay dịu dàng và ấm áp
            nhất.
          </p>
        </div>
      </section>
      <AboutBrand />
      {/* Quote band */}
      <section className="au-quote">
        <div className="container">
          <div className="au-seal" aria-hidden>
            <svg
              viewBox="0 0 100 100"
              width="100"
              height="100"
              aria-hidden="true"
              focusable="false"
            >
              {/* vòng tròn nền */}
              <circle cx="50" cy="50" r="46" fill="#fff" stroke="#dfe7ea" />
              {/* phong bì */}
              <g
                stroke="#8bb7ae"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {/* thân phong bì */}
                <rect x="20" y="34" width="60" height="32" rx="4" />
                {/* nắp phong bì (tam giác) */}
                <path d="M20 34 L50 58 L80 34" />
                {/* đường viền giữa để gợi nếp gấp */}
                <path d="M20 34 L50 50 L80 34" />
              </g>
            </svg>
          </div>
          <blockquote>
            <p>Kính gửi: Quý khách hàng!</p>
            <p>
              Công ty Cổ Phần Thương Mại Dịch Vụ WMA xin chân thành kính chúc
              quý khách hàng và gia đình an khang thịnh vượng. WMA trân trọng
              cảm ơn quý khách hàng đã quan tâm và lựa chọn sản phẩm mang thương
              hiệu Rumi của chúng tôi.
            </p>
            <p>
              Xuất phát từ những nhà sáng lập và đội ngũ nhân sự phần đông là
              những người phụ nữ với mục tiêu không ngừng phát triển bản thân
              đồng thời cân bằng tốt giữa công việc và cuộc sống gia đình, chúng
              tôi đồng cảm và thấu hiểu những cung bậc cảm xúc của phụ nữ Việt
              trên hành trình làm mẹ. Từ sự thấu hiểu đó, toàn bộ đội ngũ WMA
              khát khao được lắng nghe và đồng hành với mỗi phụ nữ Việt trên
              hành trình nhiều hạnh phúc mà cũng nhiều gian nan này. Đồng thời,
              WMA cam kết đem đến nhiều sản phẩm lành - chất cùng những dịch vụ
              tận tâm đến từng bà mẹ, từng em bé, từng gia đình Việt. Bởi vì với
              Rumi, mọi phụ nữ mọi trẻ em đều xứng đáng được yêu thương và nâng
              niu.
            </p>
            <p>Một lần nữa, kính chúc quý khách hàng An lành và Hạnh phúc!</p>
            <p>Trân trọng và biết ơn.</p>
          </blockquote>
          <div className="sig">—WMA JSC—</div>
        </div>
      </section>
      <ExplainTurtle
        headingKicker="Rùa Rumi – Biểu tượng của tình yêu, sự bảo vệ và niềm tự hào Việt "
        steps={[
          {
            title: "Thông điệp",
            body: "Rumi không chỉ là một chiếc tã, đó là sự nâng niu đầu đời dành cho bé yêu. Lấy cảm hứng từ Cụ Rùa Hồ Gươm, biểu tượng thiêng liêng của Thăng Long Hà Nội, Rumi gửi gắm thông điệp về sự trường tồn, vững chãi và lòng bao dung của người Việt.",
          },
          {
            title: "Lời nhắn nhủ",
            body: "Trên bao bì Rumi, hình ảnh thiên thần nhỏ khoác mai rùa được tạo nên như một lời nhắn nhủ: bé yêu là món quà quý giá nhất, xứng đáng được chở che trong vòng tay an toàn, êm ái và thuần khiết. Đôi cánh trắng là biểu tượng của sự thoáng mát và tự do, còn chiếc mai rùa vững vàng là lời cam kết về chất lượng và niềm tin mà Rumi dành cho mỗi gia đình Việt.",
          },
          {
            title: "Sứ mệnh",
            body: "Rùa Rumi mang trong mình tình yêu và sứ mệnh đặc biệt: trở thành người bạn nhỏ đồng hành cùng bé yêu trong những năm tháng đầu đời. Với chiếc mai rùa vững chãi, Rumi gửi gắm thông điệp về sự bảo vệ và bình an, còn đôi cánh trắng nhẹ như mây là hình ảnh của tự do, êm ái và thuần khiết. Mỗi nụ cười, mỗi giấc ngủ của bé đều được Rumi nâng niu như điều quý giá nhất. Và giữa thế giới êm đềm ấy, Rùa Rumi là biểu tượng của niềm tin, tình yêu Việt và ước muốn chở che bé yêu bằng tất cả sự dịu dàng của Rumi. ",
          },
        ]}
      />
      {/* Services / Meaning of icons */}
      {/* <section id="services" className="au-services container">
        <header className="au-services__head">
          <p className="eyebrow">TRUYỀN THÔNG NÓI GÌ VỀ</p>
          <h2>RUMI</h2>
          <span className="line" />
        </header>

        <div className="au-grid">
          <article className="au-card">
            <figure className="thumb">
              <img src="/images/proper/gl1.jpg" alt="Cloud-soft surface" />
            </figure>
            <h3>Truyền Hình VTV</h3>
            <p>
              Rumi hân hạnh được đồng hành cùng VTV trong chương trình Chào buổi
              sáng để giới thiệu về sản phẩm tã bỉm an toàn, chất lượng dành cho
              bé yêu.
            </p>
            <a className="btn-media" href="#">
              View more
            </a>
          </article>

          <article className="au-card">
            <figure className="thumb">
              <img src="/images/proper/gl2.jpg" alt="Quick-dry core" />
            </figure>
            <h3>Báo Vietnamnet</h3>
            <p>
              Rumi tự hào được Vietnamnet.vn giới thiệu là thương hiệu tã bỉm
              Việt Nam chất lượng cao, mang đến sự lựa chọn an toàn và tin cậy
              cho các bậc cha mẹ.
            </p>
            <a className="btn-media" href="#">
              View more
            </a>
          </article>

          <article className="au-card">
            <figure className="thumb">
              <img src="/images/proper/gl3.jpg" alt="Leak guard wings" />
            </figure>
            <h3>Báo Dân Trí</h3>
            <p>
              Rumi vinh dự được Dân Trí đưa tin là thương hiệu tã bỉm Việt Nam
              chất lượng cao, mang đến sự lựa chọn an toàn và tin cậy cho các
              bậc cha mẹ.
            </p>
            <a className="btn-media" href="#">
              View more
            </a>
          </article>
        </div>
      </section> */}
    </main>
  );
}
